import { render, staticRenderFns } from "./OfferEditTaxes.vue?vue&type=template&id=494a2ce5&scoped=true&"
import script from "./OfferEditTaxes.vue?vue&type=script&lang=ts&"
export * from "./OfferEditTaxes.vue?vue&type=script&lang=ts&"
import style0 from "./OfferEditTaxes.vue?vue&type=style&index=0&id=494a2ce5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494a2ce5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VDataTable,VDialog,VRow})
